/* dg-promo-price v2 – shows strikethrough + discounted price for automatic collection discounts.
   Display only; the real discount is applied by Shopify automatic discounts in cart/checkout. */
(function () {
  var HOST = location.hostname.replace(/^www\./, '');
  var CONF = {
    'discgolf.ee': [
      { h: 'discgolfi-kotid', pct: 30, until: '2026-10-25T21:59:00Z' },
      { h: 'gram-discs', pct: 30, until: '2026-10-31T21:59:00Z' },
      { h: 'trilogy', pct: 25, from: '2026-10-25T22:00:00Z', until: '2026-11-01T21:59:00Z' }
    ],
    'discgolf.eu': [
      { h: 'bags', pct: 30, until: '2026-10-25T21:59:00Z' },
      { h: 'gram-discs', pct: 30, until: '2026-10-31T21:59:00Z' },
      { h: 'trilogy', pct: 25, from: '2026-10-25T22:00:00Z', until: '2026-11-01T21:59:00Z' }
    ]
  };
  var now = Date.now();
  var promos = (CONF[HOST] || []).filter(function (p) { return Date.parse(p.until) > now && (!p.from || Date.parse(p.from) <= now); });
  if (!promos.length) return;

  var css = '.dg-pp-was{text-decoration:line-through;opacity:.55;font-weight:500;margin-right:.4em;font-size:.86em}' +
    '.dg-pp-now{color:#FF5A3C!important;font-weight:800}' +
    '.dg-pp-badge{background:#FF5A3C;color:#fff;font-weight:800;font-size:12px;line-height:1;padding:6px 9px;border-radius:999px;letter-spacing:.02em}' +
    '.dg-pp-badge--abs{position:absolute;top:10px;left:10px;z-index:3}' +
    '#price-field .dg-pp-was{font-size:.7em}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var map = {}; // handle -> promo
  var KEY = 'dgpp3:' + HOST + ':' + promos.map(function (p) { return p.h; }).join(',');

  function fmt(orig, val) {
    // keep the original money format (currency symbol position, decimal separator)
    var m = orig.match(/\d[\d\s.,]*\d|\d/);
    if (!m) return null;
    var num = m[0], dec = ',', hasDec = /[.,]\d{2}$/.test(num);
    if (hasDec) dec = num.charAt(num.length - 3);
    var s = val.toFixed(2);
    if (!hasDec && Math.round(val) === val) s = String(Math.round(val));
    else s = s.replace('.', dec);
    return orig.slice(0, m.index) + s + orig.slice(m.index + num.length);
  }
  function parse(txt) {
    var m = txt.match(/\d[\d\s.,]*\d|\d/);
    if (!m) return NaN;
    var n = m[0].replace(/\s/g, '');
    if (/[.,]\d{2}$/.test(n)) n = n.slice(0, -3).replace(/[.,]/g, '') + '.' + n.slice(-2);
    else n = n.replace(/[.,]/g, '');
    return parseFloat(n);
  }
  function moneyText(el) {
    // text of .money without sr-only label
    var t = '';
    el.childNodes.forEach(function (n) {
      if (n.nodeType === 3) t += n.textContent;
      else if (!(n.classList && (n.classList.contains('sr-only') || n.classList.contains('visually-hidden')))) t += n.textContent;
    });
    return t.trim();
  }
  function apply(el, promo) {
    if (!el || el.getAttribute('data-dgpp') === '1') return;
    var txt = moneyText(el); var v = parse(txt);
    if (!(v > 0)) return;
    var nv = Math.round(v * (100 - promo.pct)) / 100;
    var lead = '';
    var mm = txt.match(/\d[\d\s.,]*\d|\d/);
    var cur = txt.slice(mm.index).replace(/^\s+/, '');
    var prefix = txt.slice(0, mm.index); // e.g. "alates €"
    var sym = prefix.replace(/^[^€$£]*/, '');
    lead = prefix.slice(0, prefix.length - sym.length);
    var was = sym + cur, nowTxt = fmt(was, nv);
    var sr = el.querySelector('.sr-only,.visually-hidden');
    el.innerHTML = '';
    if (sr) el.appendChild(sr);
    if (lead) el.appendChild(document.createTextNode(lead));
    var s = document.createElement('s'); s.className = 'dg-pp-was'; s.textContent = was;
    var n = document.createElement('span'); n.className = 'dg-pp-now'; n.textContent = nowTxt;
    el.appendChild(s); el.appendChild(n);
    el.setAttribute('data-dgpp', '1');
  }
  function handleOf(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function primaryMoney(scope) {
    var list = scope.querySelectorAll('.money');
    for (var i = 0; i < list.length; i++) {
      var e = list[i];
      if (e.closest('s,del,select,option,[class*=compare],.dg-pp-was')) continue;
      return e;
    }
    return null;
  }
  function scan() {
    // product cards (USF grid, dg-card sections, search)
    document.querySelectorAll('.indiv-product').forEach(function (card) {
      if (card.getAttribute('data-dgpp-card') === '1' && card.querySelector('[data-dgpp="1"]')) return;
      var a = card.querySelector('a[href*="/products/"]');
      var p = a && map[handleOf(a.getAttribute('href'))];
      if (!p) return;
      var el = primaryMoney(card);
      apply(el, p);
      if (!card.querySelector('.dg-pp-badge')) {
        var b = document.createElement('span'); b.className = 'dg-pp-badge'; b.textContent = '−' + p.pct + '%';
        var holder = card.querySelector('.dg-badges');
        if (holder) holder.insertBefore(b, holder.firstChild);
        else {
          var media = card.querySelector('.collection-image--zoom-effect') || card;
          if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
          b.className += ' dg-pp-badge--abs'; media.appendChild(b);
        }
      }
      card.setAttribute('data-dgpp-card', '1');
    });
    // product page
    var h = handleOf(location.pathname);
    if (h && map[h]) {
      var pf = document.getElementById('price-field');
      if (pf) apply(primaryMoney(pf) || pf.querySelector('.money'), map[h]);
    }
  }
  function start() {
    scan();
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 60); })
      .observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  function load(p) {
    var out = [], page = 1;
    function next() {
      return fetch('/collections/' + p.h + '/products.json?limit=250&page=' + page, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) {
          (j.products || []).forEach(function (x) { out.push(x.handle); });
          if ((j.products || []).length === 250 && page < 8) { page++; return next(); }
          return out;
        });
    }
    return next();
  }
  var cached = null;
  try { cached = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
  var ready = (cached && cached.t > now - 30 * 60 * 1000)
    ? Promise.resolve(cached.d)
    : Promise.all(promos.map(load)).then(function (lists) {
        var d = {};
        lists.forEach(function (l, i) { l.forEach(function (h) { d[h] = promos[i].h; }); });
        try { sessionStorage.setItem(KEY, JSON.stringify({ t: now, d: d })); } catch (e) {}
        return d;
      });
  ready.then(function (d) {
    var byH = {}; promos.forEach(function (p) { byH[p.h] = p; });
    Object.keys(d).forEach(function (h) { if (byH[d[h]]) map[h] = byH[d[h]]; });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  }).catch(function () {});
})();
